import {useEffect, useState} from "react";
import transactionFetchService from "../../../service/transactionFetchService";
import {AccountWiseFundDetailWrapperDto} from "../../../dto/AccountWiseFundDetailWrapperDto";
import {CommonAxiosSuccessResponseDto} from "../../../dto/CommonAxiosSuccessResponseDto";
import ErrorHandler from "../../../util/ErrorHandler";
import CommonSwitchWithdrawTransferMoneyComp from "./commonSwitchWithdrawTransferMoneyRequestsComp";
import {DOC_CODE_SWITCH_TRANSACTION_DOCUMENT} from "../../../util/Constants";

const SwitchMoneyRequestsComp = () => {

    const [transactionSwitchMoneyData, setTransactionSwitchMoneyData] =
        useState<AccountWiseFundDetailWrapperDto[]>([])

    const [isLoading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        getPendingSwitchFundRequest();
    }, [])

    const getPendingSwitchFundRequest = () => {
        setLoading(true)
        transactionFetchService.getPendingSwitchFundRequest().then(
            (res: CommonAxiosSuccessResponseDto<AccountWiseFundDetailWrapperDto[]>) => {
                if (res.data) {
                    setLoading(false)
                    setTransactionSwitchMoneyData(res.data.results)
                }
            }).catch((res) => {
            setLoading(false)
            ErrorHandler.handleError(res)
        })
    }

    return (
        <>
            <CommonSwitchWithdrawTransferMoneyComp
                transactionSwitchMoneyData={transactionSwitchMoneyData}
                isLoading={isLoading}
                transactionType={"SWITCH"}
                documentCode={DOC_CODE_SWITCH_TRANSACTION_DOCUMENT}
                reloadTable={getPendingSwitchFundRequest}
            />
        </>
    )
}
export default SwitchMoneyRequestsComp;